const crmMain = [
  {
    path: "/:appId/crm",
    name: "crm",
    meta: { title: "CRM" },
    redirect: {
      name: "crm.crm.dashboard",
    },
  },
  {
    path: "/:appId/crm/dashboard",
    name: "crm.crm.dashboard",
    component: () => import("@/views/crm/dashboard/DashboardMain.vue"),
    meta: { title: "CRM Dashboard" },
  },
  {
    path: "/:appId/crm/activities",
    name: "crm.crm.activities",
    component: () => import("@/views/crm/activities/ActivitiesMain.vue"),
    meta: { title: "CRM Activities" },
  },
  {
    path: "/:appId/crm/coaching",
    name: "crm.crm.coaching",
    component: () => import("@/views/crm/coaching/CoachingMain.vue"),
    meta: { title: "CRM Coaching" },
  },
  {
    path: "/:appId/crm/contact",
    name: "crm.crm.contact",
    component: () => import("@/views/crm/contact/ContactMain.vue"),
    meta: { title: "CRM Contact" },
  },
  {
    path: "/:appId/crm/deals",
    name: "crm.crm.deals",
    component: () => import("@/views/crm/deals/DealsMain.vue"),
    meta: { title: "CRM Deals" },
  },
  {
    path: "/:appId/crm/leads",
    name: "crm.crm.leads",
    component: () => import("@/views/crm/leads/LeadsMain.vue"),
    meta: { title: "CRM Leads" },
  },
  {
    path: "/:appId/crm/leads/:id",
    name: "crm.crm.leads.detail",
    component: () => import("@/views/crm/leads/leads-detail/LeadsDetail.vue"),
    meta: { title: "CRM Lead Detail" },
  },
  {
    path: "/:appId/crm/property",
    name: "crm.crm.property",
    component: () => import("@/views/crm/property/PropertyMain.vue"),
    meta: { title: "CRM Property" },
  },
  {
    path: "/:appId/crm/report",
    name: "crm.crm.report",
    component: () => import("@/views/crm/report/ReportMain.vue"),
    meta: { title: "CRM Report" },
  },
  {
    path: "/:appId/crm/report/agent-performance",
    name: "crm.crm.report.agent-performance",
    component: () =>
      import(
        "@/views/crm/report/agent-performance/ReportAgentFollowUpPerformanceMain.vue"
      ),
    meta: { title: "CRM Report Agent Performance" },
  },
  {
    path: "/:appId/crm/report/follow-up-summary",
    name: "crm.crm.report.follow-up-summary",
    component: () =>
      import("@/views/crm/report/follow-up/ReportFollowUpSummaryMain.vue"),
    meta: { title: "CRM Report Follow Up Call Outcome Summary" },
  },
  {
    path: "/:appId/crm/report/summary-statuses",
    name: "crm.crm.report.summary-statuses",
    component: () =>
      import(
        "@/views/crm/report/summary-statuses/ReportSummaryStatusesMain.vue"
      ),
    meta: { title: "CRM Report Successful vs Unsuccessful Outcomes" },
  },
  {
    path: "/:appId/crm/report/leads-overview",
    name: "crm.crm.report.leads-overview",
    component: () =>
      import("@/views/crm/report/leads-overview/ReportLeadsOverview.vue"),
    meta: { title: "CRM Report Leads Overview" },
  },
  {
    path: "/:appId/crm/report/qualified-unqualified-result",
    name: "crm.crm.report.qualified-unqualified-result",
    component: () =>
      import(
        "@/views/crm/report/qualified-unqualified/ReportQualifiedVSUnqualified.vue"
      ),
    meta: { title: "CRM Report Qualified vs Unqualified Results" },
  },
  {
    path: "/:appId/crm/report/unqualified-breakdown",
    name: "crm.crm.report.unqualified-breakdown",
    component: () =>
      import(
        "@/views/crm/report/unqualified-breakdown/ReportUnqualifiedBreakdown.vue"
      ),
    meta: { title: "CRM Report Unqualified Reason Breakdown" },
  },
  {
    path: "/:appId/crm/report/agent-status-changes",
    name: "crm.crm.report.agent-status-change",
    component: () =>
      import(
        "@/views/crm/report/agent-status-change/ReportAgentStatusChange.vue"
      ),
    meta: { title: "CRM Report Unqualified Reason Breakdown" },
  },
  {
    path: "/:appId/crm/report/agent-follow-up-acitivies",
    name: "crm.crm.report.agent-follow-up-acitivies",
    component: () =>
      import(
        "@/views/crm/report/agent-follow-up-acitivies/Reportagentfollowupacitvities.vue"
      ),
    meta: { title: "CRM Report Agent Follow Up Activities" },
  },
  {
    path: "/:appId/crm/report/lead-submission",
    name: "crm.crm.report.lead-submission",
    component: () =>
      import(
        "@/views/crm/report/lead-submission/ReportLeadSubmission.vue"
      ),
    meta: { title: "CRM Report Lead Submission" },
  },
  {
    path: "/:appId/crm/settings",
    name: "crm.crm.settings",
    component: () => import("@/views/crm/settings/SettingsMain.vue"),
    meta: { title: "CRM Settings" },
  },
];
export default crmMain;
